import { useAuth } from "../../../hooks"
import { Login } from "../.."
import { ExistingAccountInvitation } from "./ExistingAccountInvitation"

export const ExistingAccount = () => {
  const authHook = useAuth()

  return authHook?.user ? <ExistingAccountInvitation /> : <Login />
}
